import { colors, fontSize, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const breadCrumbContainer = css`
  display: flex;
  justify-content: center;
  height: 35px;
  margin-top: -20px;
  padding: 10px 0;
  background-color: ${colors.gray[2]};
`;

export const calloutContainer = css`
  display: flex;
  padding: 10px;
  background-color: ${colors.danger.a2};

  & svg {
    width: 16px;
    height: 16px;
    align-self: center;
    margin-right: 10px;
    color: ${colors.danger[10]};
  }
`;

export const buttonFAQ = css`
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.xs};

  && {
    color: ${colors.primary[9]};
    text-decoration: none;
  }

  &:hover {
    color: ${colors.primary[10]};
    cursor: pointer;
  }
`;

export const titleContainer = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px;
  background-color: ${colors.gray[2]};
`;

export const infoContainer = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const select = css`
  width: 300px;
  margin-top: 10px;
`;

export const bodyText = css`
  margin: 10px 0 15px;
  text-align: center;
`;

export const wrapper = css`
  display: flex;
  flex-direction: column;
  width: 480px;
`;

export const headerWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: ${colors.gray[2]};
`;

export const verticalDivider = css`
  && {
    height: 40px;
  }
`;

export const contentWrapper = css`
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
`;

export const actionButton = css`
  width: 170px;
  margin: 20px 30px 20px auto;
`;

export const mapContainer = css`
  position: relative;
  width: 100%;
  height: 300px;
`;

export const map = css`
  width: 100%;
  height: 300px;
`;

export const mapOverlay = css`
  width: 100%;
  height: 250px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
